import { RightEnum } from "@finway-group/shared/lib/models"
import { Button, Tabs } from "antd"
import React, { useCallback, useState } from "react"
import { Plus as PlusIcon } from "react-feather"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import { FilterLegacy } from "~Components/filter/FilterLegacy"
import VendorFormModal from "~Components/modals/vendor.modal"
import { PageTitle } from "~Components/page/pageTitle"
import SearchInput from "~Components/searchInput"
import { useCompany } from "~Shared/hooks/company.hooks"
import { applyFilter } from "~Shared/hooks/filter.hooks"
import { defaultQueryParams } from "~Shared/queries/vendors/consts"
import { AuthzService, VendorService } from "~Shared/services"
import { setCurrentPage, setSearchValue } from "~Shared/store/actions/tableConfig/tableConfigActions"
import { TablesEnum } from "~Shared/store/reducers/tableConfigReducer"
import useStateIfMounted from "~Shared/utils/hooks/useStateIfMounted"
import MassExportButton from "../../../components/massExport.button"
import { useVendorTable } from "../../../shared/hooks/useVendorTable.hooks"
import EmployeeVendorTable from "./employeeVendor.table"
import VendorTable from "./vendor.table"

export const VendorsList = () => {
    const dispatch = useDispatch()
    const { t } = useTranslation()
    const [activeTab, setActiveTab] = useStateIfMounted(TablesEnum.VENDORS)
    const [isModalShowing, setIsModalShowing] = useState(false)
    const { isVendorCreationRestricted } = useCompany()

    const { shouldShowSearch, queryParams } = useVendorTable()

    const handleSearch = useCallback(
        (value: string) => {
            dispatch(setSearchValue(TablesEnum.VENDORS, value))
        },
        [dispatch],
    )

    return (
        <div>
            <PageTitle titleKey="view:vendors.title">
                {activeTab === TablesEnum.VENDORS && (
                    <>
                        {shouldShowSearch && <SearchInput onSearch={handleSearch} value={queryParams.search} />}
                        <FilterLegacy
                            // keep line breaks
                            table={TablesEnum.VENDORS}
                            onFilter={(data) => {
                                dispatch(setCurrentPage(TablesEnum.VENDORS, defaultQueryParams.page))
                                return applyFilter(TablesEnum.VENDORS, data)
                            }}
                            options={{}}
                        />
                        <MassExportButton serviceExportFunction={VendorService.export} visible={AuthzService.isRightGrantedForLoggedInUser(RightEnum.VENDOR__ALL__READ)} />
                        {VendorService.shouldShowVendorButton(isVendorCreationRestricted) && (
                            <Button data-testid="createVendorButton" type="primary" onClick={() => setIsModalShowing(true)}>
                                <PlusIcon />
                                <span>{t("action:vendor:create")}</span>
                            </Button>
                        )}
                        {isModalShowing && <VendorFormModal isNew={true} isShowing={isModalShowing} onCancel={setIsModalShowing} />}
                    </>
                )}
            </PageTitle>
            <Tabs
                defaultActiveKey={TablesEnum.VENDORS}
                onChange={(e: TablesEnum) => {
                    setActiveTab(e)
                }}
            >
                <Tabs.TabPane key={TablesEnum.VENDORS} tab={t("label:vendors")}>
                    <VendorTable onAddVendor={setIsModalShowing} />
                </Tabs.TabPane>
                <Tabs.TabPane key={TablesEnum.EMPLOYEE_VENDORS} tab={t("label:employees")}>
                    <EmployeeVendorTable />
                </Tabs.TabPane>
            </Tabs>
        </div>
    )
}
